import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bmi-calculator',
  component: () => import('../../routes/BmiCalculator.svelte'),
  card: {
    id: 'bmi-calculator',
    title: 'BMI Calculator',
    description: 'Calculate your Body Mass Index (BMI) and see your weight category, healthy weight range, and estimated body fat percentage.',
    icon: 'monitor_weight',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/bmi-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'BMI Calculator – Body Mass Index Calculator',
    description: 'Free BMI calculator to check your Body Mass Index. Enter your height and weight to instantly see your BMI category, healthy weight range, and estimated body fat percentage.',
  },
};

export default meta;
